import { Weekday } from './weekday.js';

export function name(day: Weekday): string {
  switch (day) {
    case Weekday.Sun:
      return 'Sunday';
    case Weekday.Mon:
      return 'Monday';
    case Weekday.Tue:
      return 'Tuesday';
    case Weekday.Wed:
      return 'Wednesday';
    case Weekday.Thu:
      return 'Thursday';
    case Weekday.Fri:
      return 'Friday';
    case Weekday.Sat:
      return 'Saturday';
  }
}

export function allDaysStartingWithMonday(): Weekday[] {
  return [
    Weekday.Mon,
    Weekday.Tue,
    Weekday.Wed,
    Weekday.Thu,
    Weekday.Fri,
    Weekday.Sat,
    Weekday.Sun,
  ];
}

export function toIsoDayNumber(day: Weekday): number {
  switch (day) {
    case Weekday.Sun:
      return 0;
    case Weekday.Mon:
      return 1;
    case Weekday.Tue:
      return 2;
    case Weekday.Wed:
      return 3;
    case Weekday.Thu:
      return 4;
    case Weekday.Fri:
      return 5;
    case Weekday.Sat:
      return 6;
  }
}

export function fromIsoDayNumber(isoDayNumber: number): Weekday {
  switch (isoDayNumber) {
    case 0:
      return Weekday.Sun;
    case 1:
      return Weekday.Mon;
    case 2:
      return Weekday.Tue;
    case 3:
      return Weekday.Wed;
    case 4:
      return Weekday.Thu;
    case 5:
      return Weekday.Fri;
    case 6:
      return Weekday.Sat;
    default:
      throw new Error('Invalid ISO day number');
  }
}
